import { render } from "./clientlist.vue?vue&type=template&id=616cbcaf"
import script from "./clientlist.vue?vue&type=script&lang=js"
export * from "./clientlist.vue?vue&type=script&lang=js"

import "./clientlist.vue?vue&type=style&index=0&id=616cbcaf&lang=css"
import "./clientlist.vue?vue&type=style&index=1&id=616cbcaf&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__